import { render } from "./Pep.vue?vue&type=template&id=40f1f4b8&scoped=true"
import script from "./Pep.vue?vue&type=script&lang=js"
export * from "./Pep.vue?vue&type=script&lang=js"

import "./Pep.vue?vue&type=style&index=0&id=40f1f4b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f1f4b8"]])

export default __exports__